module.exports = __webpack_public_path__ + "static/img/fz_rb_ys.a43b230.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_rb_ys.png
// module id = TyYk
// module chunks = 0